"use client";

import { Info } from "lucide-react";
import Link from "next/link";
import { Modal, ModalFooter, Button } from "@/components/ui";
import { Locale } from "@/i18n-config";

interface SubscriptionLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage?: string;
  lang: Locale;
  title?: string;
  description?: string;
  closeButtonText?: string;
  viewPlansButtonText?: string;
}

/**
 * Reusable modal component for displaying subscription limit errors
 * Shows a user-friendly message and provides a link to the subscription page
 */
export function SubscriptionLimitModal({
  isOpen,
  onClose,
  errorMessage,
  lang,
  title = "Abonelik Limiti",
  description = "Daha fazla kayıt oluşturabilmek için abonelik planınızı yükseltmeniz gerekmektedir.",
  closeButtonText = "Kapat",
  viewPlansButtonText = "Abonelik Planlarını Görüntüle",
}: SubscriptionLimitModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="md">
      <div className="space-y-4">
        {/* Info Box */}
        <div className="flex items-start gap-3 px-4 py-3.5 bg-info-glow-12 border border-info-glow-20 rounded-[10px]">
          <Info className="w-5 h-5 text-info-light shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-foreground leading-[1.5]">
              {errorMessage || "Kayıt oluşturma limitinize ulaştınız."}
            </p>
          </div>
        </div>

        {/* Description */}
        <p className="text-sm text-muted-foreground leading-[1.6]">
          {description}
        </p>

        {/* Actions */}
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            {closeButtonText}
          </Button>
          <Link href={`/${lang}/subscription`}>
            <Button>{viewPlansButtonText}</Button>
          </Link>
        </ModalFooter>
      </div>
    </Modal>
  );
}
